import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.extraClass
*/

const UniIndent = (props) => {
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }
  return (
    <div className={"unicompo-indent" + extraClass}>{props.children}</div>
  );
};

export default UniIndent;